<template>
  <div class="gallery">
    <div class="header">
      <div class="header_section">
        <router-link to="/profile" class="header_element header_icone mobile">
          <!--          <span class="icon icon-left-arrow icon-lg"></span>-->
          <font-awesome-icon color="#00d7fe" class="reverse" icon="angle-right"/>

        </router-link>
        <h1 class="header_element">Galerie</h1>
      </div>


    </div>
    <!--    <div class="content_option">-->
    <!--      <p v-on:click="changeSelected(true)" :class=" isAnims ? 'selected' : ''">Anims</p>-->
    <!--                  <p v-on:click="changeSelected(false)" :class=" isAnims ? '' : 'selected'">Pellicule</p>-->
    <!--    </div>-->
    <section v-if="isAnims" class="container">
      <transition-group class="mediaContainer" name="list" enter-active-class="animated bounceIn"
                        leave-active-class="animated bounceOut">

        <div
            v-for="(media, index) in medias"
            class="media"
            :key="index+'p'"
        >
          <img
              :src="media.src"
              @click="openGallery(index)"
          >
          <div class="options" @click="addActive($event)">
            <div class="dots"></div>
            <div class="dots"></div>
            <div class="dots"></div>
            <div class="list-options">
              <span :id="media.id" class="trash" @click="deleteItem(media.id)">SUPPRIMER</span>
              <!--          <span class="share" @click="downloadItem(media.src)"><font-awesome-icon icon="share-square"/></span>-->
            </div>
          </div>
        </div>

      </transition-group>


      <LightBox
          v-if="medias"
          ref="lightbox"
          :media="medias"
          :showLightBox="false"
          :showThumbs="false"
      />
      <div v-if="!medias ||medias.length<1" class="empty-case">
        <div class="empty">AUCUNE IMAGE DANS LA GALLERIE</div>
      </div>
    </section>
    <section v-else>
      <li v-for="(img, index) in medias" v-bind:key="index+'p'">
        <img :src="img.src" alt="" height="100">
      </li>
    </section>

  </div>
</template>

<script>
import {store} from '../store/store';
import {mapState, mapActions} from "vuex";

import LightBox from 'vue-image-lightbox'

export default {
  name: 'gallery',
  components: {
    LightBox,
  },
  data() {
    return {
      // medias:store.getters.getMedias,
      isAnims: true,
      medias: null
    }
  },
  computed: {},
  methods: {
    ...mapActions([
      'dropPicture',
      'getUserPictures'
    ]),
    getImage(image) {
      return require('../asset/' + image)
    },
    deleteItem(id) {
      const index = this.medias.findIndex(media => media.id === id);
      this.medias.splice(index, 1);
      this.dropPicture(id);
      store.commit('setMedias', this.medias);
    },
    changeSelected(ifAdmin) {
      this.isAnims = ifAdmin;
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index)
    },
    downloadItem(url) {

    },
    addActive(e) {

      if (e.currentTarget.classList.contains('active')) {
        document.querySelector('.active').classList.remove('active')
        e.currentTarget.lastChild.classList.remove('active')


      } else if (document.querySelector('.active')) {
        document.querySelector('.active').classList.remove('active')


      } else {
        e.currentTarget.classList.add('active')
        e.currentTarget.lastChild.classList.add('active')

      }

    }
  },
  mounted() {
    // this.medias = localStorage.getItem('medias')
    !localStorage.getItem('user') && this.$router.push({name: "login", params: {type: 'connexion'}});

    this.getUserPictures().then(res => {
      this.medias = res
    })
  }
}
</script>

<style scoped>
@import "https://use.fontawesome.com/releases/v5.0.6/css/all.css";
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

body {
  background: #EFEFEF;
}

.gallery {
  z-index: 1;
}

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.header_section {
  display: flex;
  align-items: center;
  text-align: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}


.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.content_option {
  /*display: flex;*/
  /*justify-content: space-evenly;*/
  color: gray;
}

.container {
  padding: 20px;
}

.content_option p {
  font-weight: bold;
  font-size: 30px;
}

.selected {
  color: #00d6ff;
  border-bottom: 3px solid #00d6ff;
}

.empty-case {
  display: flex;
}

.empty-case > * {
  color: #bebebe;
  font-family: Poppins;
  padding: 20px;
  margin: auto;
}

.media img {
  width: 100%;
  height: 200px;
  transform: translate(0px, 0px) rotateY(180deg);
  text-align: center;
  object-fit: cover;
}

.mediaContainer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.media {
  /*flex: 1 0 auto;*/
  position: relative;
  margin: 10px;
  /*width: 30%;*/
}

.mobile {
  display: none;
}

@media screen and (max-width: 750px) {
  .media {
    width: 30%;
  }

  .mobile {
    display: block;
  }

  .media img {
    height: 100%;
  }
}


.share:hover {
  cursor: pointer;
  color: #00d6ff;
}

.trash:hover {
  cursor: pointer;
  color: red;
}

.duration {
  right: 5px;
}

.options {
  border-radius: 20px;
  position: absolute;
  top: 3px;
  right: 3px;
  display: flex;
  flex-direction: column;
  /*background: #3838386b;*/
  padding: 5px;
}

.options .dots {
  margin: 2px;
  padding: 3px;
  background: #000;
  border-radius: 50%;
  transition: .3s;
}

.options:hover {
  cursor: pointer;
}

.options:hover .dots {
  background: #00A8EF;
  cursor: pointer;
}

.options.active .dots:nth-child(2) {
  display: none;
}

.options.active .dots:first-child {
  border-radius: 8px;
  width: 20px;
  transform: rotate(45deg);
}

.options.active .dots:nth-child(3) {
  border-radius: 8px;
  width: 20px;
  position: absolute;
  transform: rotate(-45deg);
}

.list-options {
  padding: 5px;
  background: grey;
  position: absolute;
  top: 30px;
  display: none;
  flex-direction: column;
}

.list-options.active {
  display: flex;
}

.share {
  right: 5px;
}

</style>
<style src="../asset/lightBoxStyle.css"></style>
